import { render, staticRenderFns } from "./pushIndex.vue?vue&type=template&id=0b1a6aa8&scoped=true&"
import script from "./pushIndex.vue?vue&type=script&lang=js&"
export * from "./pushIndex.vue?vue&type=script&lang=js&"
import style0 from "./pushIndex.vue?vue&type=style&index=0&id=0b1a6aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a6aa8",
  null
  
)

export default component.exports